import { Controller } from "react-hook-form";
import {
  ClickMaxAmount,
  DetailButtonHeader,
  LoadingRouterWrapper,
  RecTag,
  RoutesRecommendItem,
  RoutesRecommendLeft,
  RoutesRecommendRight,
  RoutesRecommended,
  SwapChoose,
  SwapChooseDefault,
  SwapContent,
  SwapDetailButton,
  SwapExchangeIcon,
  SwapInput,
  SwapInputTitle,
  SwapInputValue,
  SwapInputWrapper,
  SwapRoutesCheck,
  SwapWrapperButtons,
} from "../../styled";
import { TextResult } from "../../ChooseToken/styled";
import InputCommon from "../../../../../components/Common/Input";
import { Checkbox } from "antd";
import { ButtonCommon } from "../../../../../Layout/styled";
import { convertFixed } from "../../../../../utils/convertFormatNumber";
import default_token_image from "../../../../../assets/Dashboard/Common/default-token-image.png";
import swap_btn_icon from "../../../../../assets/Dashboard/Swap/swap_btn_icon.svg";
import wallet_icon from "../../../../../assets/Dashboard/Swap/wallet_icon.svg";
import { useContext, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import SwapDetails from "../Details";
import { ContextProviderWrapper } from "../../../../../components/Context";
import { Coins } from "ton3-core";
import { useAppKit, useAppKitAccount } from "@reown/appkit/react";
import LoadingSpin from "../../../../../components/Common/Loading";
import { useTonAddress, useTonConnectUI } from "@tonconnect/ui-react";
import useSwapFeeCheck from "../../../../../hooks/useSwapFeeCheck";
import { useNativePrice } from "../../../../../hooks/useNativePrice";

const SwapModal = ({
  fromAssetBalance,
  fromAsset,
  debouncedUpdateFromAmount,
  fromAmount,
  setOpenFromModal,
  control,
  handleSendValue,
  swapFromTo,
  toAssetBalance,
  toAsset,
  toAmount,
  setOpenToModal,
  handleReceiveValue,
  simulateState,
  setOpenConfirmModal,
  realPrice,
  slippageTolerance,
  minReceived,
  setShowDetail,
  showDetail,
  handleResetValueFrom,
  handleResetValueTo,
  onSelectRoute,
  keySelected,
  loadingRouter,
  chainRouter,
  nativeTokenBalance,
}: any) => {
  const { address } = useAppKitAccount();
  const { open } = useAppKit();
  const [tonConnectUI] = useTonConnectUI();
  const addressTon = useTonAddress();
  const [expandRoutes, setExpandRoutes] = useState(true);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const { theme } = useContext(ContextProviderWrapper)!;
  const [dataBestRoute, setDataBestRoute] = useState<any>(null);
  const [dataOrtherRoute, setDataOrtherRoute] = useState<any>([]);
  const handleCheckMultiRoutes = (e: any) => {
    setExpandRoutes(e.target.checked);
    const isRubic = dataOrtherRoute.find((item: any) => item.key === "rubic");
    if (e.target.checked && isRubic && Object.keys(isRubic).length > 0) {
      onSelectRoute("rubic");
    }
  };

  const nativePriceUsd = useNativePrice(chainRouter);

  const isFeeEnough = useSwapFeeCheck({
    gasFeeUsd: Number(simulateState?.bestRoute?.gasUsd),
    balance: Number(nativeTokenBalance),
    fromAmount: Number(fromAmount),
    nativeTokenPriceUsd: Number(nativePriceUsd),
    loading: loadingRouter
  });

  useEffect(() => {
    if (simulateState && simulateState?.bestRoute) {
      setDataBestRoute(simulateState?.bestRoute);
    }

    if (simulateState && simulateState?.ortherRoute) {
      setDataOrtherRoute(simulateState?.ortherRoute);
    }
  }, [simulateState?.timestamp]);

  useEffect(() => {
    if (Number(fromAmount) === 0) {
      setDataBestRoute(null);
      setDataOrtherRoute([]);
    }
  }, [fromAmount]);

  return (
    <>
      <SwapContent>
        <SwapInput className={`exchange ${theme}`}>
          <SwapInputTitle className={theme}>
            <p>You send:</p>
            <ClickMaxAmount>
              {!isMobile && "Balance:"}{" "}
              {convertFixed(Number(fromAssetBalance.toString()))} |{" "}
              <span
                onClick={() => {
                  debouncedUpdateFromAmount(
                    Number(fromAssetBalance.toString())
                  );
                }}
              >
                MAX
              </span>
            </ClickMaxAmount>
          </SwapInputTitle>
          <SwapInputWrapper
            className={theme}
            style={{
              cursor: address ? "pointer" : "not-allowed",
            }}
            active={fromAmount > 0}
          >
            <SwapChoose
              className={theme}
              onClick={() => {
                setOpenFromModal(true);
              }}
            >
              <SwapChooseDefault className={theme}>
                {fromAsset ? (
                  <>
                    <img
                      src={fromAsset?.img}
                      alt="icon"
                      onError={(e) =>
                        (e.currentTarget.src = default_token_image)
                      }
                    />
                    <p>{fromAsset?.symbol}</p>
                  </>
                ) : (
                  <TextResult>Loading...</TextResult>
                )}
              </SwapChooseDefault>
            </SwapChoose>
            {/* Input From */}
            <Controller
              name="fromAmount"
              control={control}
              render={({ field }: any) => (
                <SwapInputValue>
                  <InputCommon
                    {...field}
                    onChange={handleSendValue}
                    onFocus={handleResetValueFrom}
                    placeHolder={"0"}
                  />
                </SwapInputValue>
              )}
            />
            {/* ---------- */}
          </SwapInputWrapper>
        </SwapInput>
        <SwapExchangeIcon
          className={theme}
          onClick={async () => {
            swapFromTo();
          }}
        >
          <img
            src={
              "https://dev-kibble-avax.netlify.app/assets/images/swap/img-swap-v2.png"
            }
            alt="exchange"
          />
        </SwapExchangeIcon>
        <SwapInput className={`exchange ${theme}`}>
          <SwapInputTitle className={theme}>
            <p>You receive:</p>
            <ClickMaxAmount>
              {!isMobile && "Balance:"}{" "}
              {convertFixed(Number(toAssetBalance.toString()))}
            </ClickMaxAmount>
          </SwapInputTitle>
          <SwapInputWrapper
            className={theme}
            style={{
              cursor: address ? "pointer" : "not-allowed",
            }}
            active={toAmount > 0}
          >
            <SwapChoose
              className={theme}
              onClick={() => {
                setOpenToModal(true);
              }}
            >
              <SwapChooseDefault className={theme}>
                {fromAsset ? (
                  <>
                    <img
                      src={toAsset?.img}
                      alt="icon"
                      onError={(e) =>
                        (e.currentTarget.src = default_token_image)
                      }
                    />
                    <p>{toAsset?.symbol}</p>
                  </>
                ) : (
                  <TextResult>Loading...</TextResult>
                )}
              </SwapChooseDefault>
            </SwapChoose>
            {/* Input to */}
            <Controller
              name="toAmount"
              control={control}
              disabled
              render={({ field }: any) => (
                <SwapInputValue>
                  <InputCommon
                    {...field}
                    onChange={handleReceiveValue}
                    onFocus={handleResetValueTo}
                    placeHolder={"0"}
                  />
                </SwapInputValue>
              )}
            />
            {/* ------- */}
          </SwapInputWrapper>
        </SwapInput>
        {loadingRouter ? (
          <LoadingRouterWrapper>
            <LoadingSpin text="Loading routers..." />
          </LoadingRouterWrapper>
        ) : (
          <>
            {fromAmount !== 0 && toAmount !== 0 && dataBestRoute && (
              <SwapRoutesCheck className={theme}>
                <Checkbox
                  onChange={handleCheckMultiRoutes}
                  checked={expandRoutes}
                >
                  Route auto select
                </Checkbox>
                {expandRoutes && (
                  <RoutesRecommended>
                    {dataOrtherRoute.find(
                      (item: any) =>
                        item.key === "rubic" && item.data.destAmount !== "NaN"
                    ) ? (
                      <RoutesRecommendItem className={theme}>
                        <RoutesRecommendLeft>
                          <div className="row-left">
                            <div className="row-left">
                              <div className="img-coin">
                                <img
                                  src={
                                    dataOrtherRoute.find(
                                      (item: any) => item.key === "rubic"
                                    )?.data?.aggregator_logo
                                  }
                                  alt="img"
                                />
                              </div>
                              <h1>
                                {
                                  dataOrtherRoute.find(
                                    (item: any) => item.key === "rubic"
                                  )?.data?.aggregator_name
                                }
                              </h1>
                            </div>
                            <RecTag
                              style={{
                                marginBottom: "3px",
                              }}
                              className={theme}
                            >
                              Recommend
                            </RecTag>
                          </div>
                          <div className="row-left">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="13"
                              height="13"
                              viewBox="0 0 13 13"
                              fill="none"
                            >
                              <path
                                d="M3.19707 3.07227V10.5723H7.99707V3.07227C7.99707 2.83357 7.90225 2.60465 7.73347 2.43587C7.56468 2.26709 7.33577 2.17227 7.09707 2.17227H4.09707C3.85838 2.17227 3.62946 2.26709 3.46067 2.43587C3.29189 2.60465 3.19707 2.83357 3.19707 3.07227ZM8.59707 9.67227V10.5723H8.89707C8.97664 10.5723 9.05294 10.6039 9.1092 10.6601C9.16546 10.7164 9.19707 10.7927 9.19707 10.8723C9.19707 10.9518 9.16546 11.0281 9.1092 11.0844C9.05294 11.1407 8.97664 11.1723 8.89707 11.1723H2.29707C2.21751 11.1723 2.1412 11.1407 2.08494 11.0844C2.02868 11.0281 1.99707 10.9518 1.99707 10.8723C1.99707 10.7927 2.02868 10.7164 2.08494 10.6601C2.1412 10.6039 2.21751 10.5723 2.29707 10.5723H2.59707V3.07227C2.59707 2.67444 2.75511 2.29291 3.03641 2.01161C3.31771 1.7303 3.69925 1.57227 4.09707 1.57227H7.09707C7.4949 1.57227 7.87643 1.7303 8.15773 2.01161C8.43904 2.29291 8.59707 2.67444 8.59707 3.07227V8.47227C8.59707 8.71096 8.69189 8.93988 8.86067 9.10866C9.02946 9.27744 9.25838 9.37227 9.49707 9.37227C9.73577 9.37227 9.96468 9.27744 10.1335 9.10866C10.3022 8.93988 10.3971 8.71096 10.3971 8.47227V5.87247C10.3971 5.67773 10.3339 5.48825 10.2171 5.33247L9.55707 4.45227C9.50933 4.38861 9.48883 4.3086 9.50009 4.22984C9.51134 4.15107 9.55342 4.08 9.61707 4.03227C9.68072 3.98453 9.76073 3.96403 9.8395 3.97528C9.91826 3.98653 9.98933 4.02861 10.0371 4.09227L10.6971 4.97247C10.8921 5.23167 10.9971 5.54787 10.9971 5.87247V8.47227C10.9971 8.75083 10.9195 9.0239 10.773 9.26086C10.6266 9.49783 10.4171 9.68933 10.1679 9.81391C9.91873 9.93849 9.6398 9.99122 9.36236 9.96621C9.08492 9.94119 8.81992 9.83941 8.59707 9.67227ZM3.79707 3.07227V5.47227C3.79707 5.55183 3.82868 5.62814 3.88494 5.6844C3.9412 5.74066 4.01751 5.77227 4.09707 5.77227H7.09707C7.17664 5.77227 7.25294 5.74066 7.3092 5.6844C7.36546 5.62814 7.39707 5.55183 7.39707 5.47227V3.07227C7.39707 2.9927 7.36546 2.91639 7.3092 2.86013C7.25294 2.80387 7.17664 2.77227 7.09707 2.77227H4.09707C4.01751 2.77227 3.9412 2.80387 3.88494 2.86013C3.82868 2.91639 3.79707 2.9927 3.79707 3.07227ZM4.39707 3.37227H6.79707V5.17227H4.39707V3.37227Z"
                                fill="#6E6E7C"
                              />
                            </svg>
                            <p>
                              $
                              {dataOrtherRoute.find(
                                (item: any) => item.key === "rubic"
                              )?.data?.gasUsd
                                ? convertFixed(
                                    Number(
                                      dataOrtherRoute.find(
                                        (item: any) => item.key === "rubic"
                                      )?.data.gasUsd
                                    )
                                  )
                                : 0}
                            </p>
                          </div>
                        </RoutesRecommendLeft>

                        <RoutesRecommendRight>
                          <h1>
                            {convertFixed(
                              Number(
                                Coins.fromNano(
                                  dataOrtherRoute.find(
                                    (item: any) => item.key === "rubic"
                                  )?.data?.destAmount
                                    ? dataOrtherRoute.find(
                                        (item: any) => item.key === "rubic"
                                      )?.data?.destAmount
                                    : 0,
                                  dataOrtherRoute.find(
                                    (item: any) => item.key === "rubic"
                                  )?.data?.destDecimals
                                    ? dataOrtherRoute.find(
                                        (item: any) => item.key === "rubic"
                                      )?.data?.destDecimals
                                    : 0
                                )
                              )
                            )}
                          </h1>
                        </RoutesRecommendRight>
                      </RoutesRecommendItem>
                    ) : (
                      <RoutesRecommendItem className={theme}>
                        <RoutesRecommendLeft>
                          <div className="row-left">
                            <div className="row-left">
                              <div className="img-coin">
                                <img
                                  src={
                                    dataOrtherRoute[0]?.data?.aggregator_logo
                                  }
                                  alt="img"
                                />
                              </div>
                              <h1>
                                {dataOrtherRoute[0]?.data?.aggregator_name}
                              </h1>
                            </div>
                            <RecTag
                              style={{
                                marginBottom: "3px",
                              }}
                              className={theme}
                            >
                              Recommend
                            </RecTag>
                          </div>
                          <div className="row-left">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="13"
                              height="13"
                              viewBox="0 0 13 13"
                              fill="none"
                            >
                              <path
                                d="M3.19707 3.07227V10.5723H7.99707V3.07227C7.99707 2.83357 7.90225 2.60465 7.73347 2.43587C7.56468 2.26709 7.33577 2.17227 7.09707 2.17227H4.09707C3.85838 2.17227 3.62946 2.26709 3.46067 2.43587C3.29189 2.60465 3.19707 2.83357 3.19707 3.07227ZM8.59707 9.67227V10.5723H8.89707C8.97664 10.5723 9.05294 10.6039 9.1092 10.6601C9.16546 10.7164 9.19707 10.7927 9.19707 10.8723C9.19707 10.9518 9.16546 11.0281 9.1092 11.0844C9.05294 11.1407 8.97664 11.1723 8.89707 11.1723H2.29707C2.21751 11.1723 2.1412 11.1407 2.08494 11.0844C2.02868 11.0281 1.99707 10.9518 1.99707 10.8723C1.99707 10.7927 2.02868 10.7164 2.08494 10.6601C2.1412 10.6039 2.21751 10.5723 2.29707 10.5723H2.59707V3.07227C2.59707 2.67444 2.75511 2.29291 3.03641 2.01161C3.31771 1.7303 3.69925 1.57227 4.09707 1.57227H7.09707C7.4949 1.57227 7.87643 1.7303 8.15773 2.01161C8.43904 2.29291 8.59707 2.67444 8.59707 3.07227V8.47227C8.59707 8.71096 8.69189 8.93988 8.86067 9.10866C9.02946 9.27744 9.25838 9.37227 9.49707 9.37227C9.73577 9.37227 9.96468 9.27744 10.1335 9.10866C10.3022 8.93988 10.3971 8.71096 10.3971 8.47227V5.87247C10.3971 5.67773 10.3339 5.48825 10.2171 5.33247L9.55707 4.45227C9.50933 4.38861 9.48883 4.3086 9.50009 4.22984C9.51134 4.15107 9.55342 4.08 9.61707 4.03227C9.68072 3.98453 9.76073 3.96403 9.8395 3.97528C9.91826 3.98653 9.98933 4.02861 10.0371 4.09227L10.6971 4.97247C10.8921 5.23167 10.9971 5.54787 10.9971 5.87247V8.47227C10.9971 8.75083 10.9195 9.0239 10.773 9.26086C10.6266 9.49783 10.4171 9.68933 10.1679 9.81391C9.91873 9.93849 9.6398 9.99122 9.36236 9.96621C9.08492 9.94119 8.81992 9.83941 8.59707 9.67227ZM3.79707 3.07227V5.47227C3.79707 5.55183 3.82868 5.62814 3.88494 5.6844C3.9412 5.74066 4.01751 5.77227 4.09707 5.77227H7.09707C7.17664 5.77227 7.25294 5.74066 7.3092 5.6844C7.36546 5.62814 7.39707 5.55183 7.39707 5.47227V3.07227C7.39707 2.9927 7.36546 2.91639 7.3092 2.86013C7.25294 2.80387 7.17664 2.77227 7.09707 2.77227H4.09707C4.01751 2.77227 3.9412 2.80387 3.88494 2.86013C3.82868 2.91639 3.79707 2.9927 3.79707 3.07227ZM4.39707 3.37227H6.79707V5.17227H4.39707V3.37227Z"
                                fill="#6E6E7C"
                              />
                            </svg>
                            <p>
                              $
                              {dataOrtherRoute[0]?.data?.gasUsd
                                ? convertFixed(
                                    Number(dataOrtherRoute[0]?.data?.gasUsd)
                                  )
                                : 0}
                            </p>
                          </div>
                        </RoutesRecommendLeft>

                        <RoutesRecommendRight>
                          <h1>
                            {convertFixed(
                              Number(
                                Coins.fromNano(
                                  dataOrtherRoute[0]?.data?.destAmount
                                    ? dataOrtherRoute[0]?.data?.destAmount
                                    : 0,
                                  dataOrtherRoute[0]?.data?.destDecimals
                                    ? dataOrtherRoute[0]?.data?.destDecimals
                                    : 0
                                )
                              )
                            )}
                          </h1>
                        </RoutesRecommendRight>
                      </RoutesRecommendItem>
                    )}
                  </RoutesRecommended>
                )}
              </SwapRoutesCheck>
            )}
            {!expandRoutes && (
              <RoutesRecommended className={theme}>
                {dataOrtherRoute.map((item: any, index: number) => {
                  if (
                    item.data.destAmount &&
                    (item.data.destAmount !== "NaN" || item.data.destAmount > 0)
                  ) {
                    return (
                      <RoutesRecommendItem
                        style={{
                          cursor: "pointer",
                          background:
                            item.key === keySelected
                              ? theme === "dark"
                                ? "#000"
                                : "#92929f"
                              : theme === "dark"
                              ? "#28272c"
                              : "#f3f4f8",
                        }}
                        key={index}
                        className={theme}
                        onClick={() => {
                          onSelectRoute(item.key);
                        }}
                      >
                        <RoutesRecommendLeft>
                          <div className="row-left">
                            <div className="row-left">
                              <div className="img-coin">
                                <img
                                  src={item?.data?.aggregator_logo}
                                  alt="img"
                                />
                              </div>
                              <h1>{item?.data?.aggregator_name}</h1>
                              {index === 0 && (
                                <RecTag
                                  style={{
                                    marginBottom: "3px",
                                  }}
                                  className={theme}
                                >
                                  Lowest fee
                                </RecTag>
                              )}
                              {item.key === "rubic" && (
                                <RecTag
                                  style={{
                                    marginBottom: "3px",
                                  }}
                                  className={theme}
                                >
                                  Fastest
                                </RecTag>
                              )}
                            </div>
                          </div>
                          <div className="row-left">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="13"
                              height="13"
                              viewBox="0 0 13 13"
                              fill="none"
                            >
                              <path
                                d="M3.19707 3.07227V10.5723H7.99707V3.07227C7.99707 2.83357 7.90225 2.60465 7.73347 2.43587C7.56468 2.26709 7.33577 2.17227 7.09707 2.17227H4.09707C3.85838 2.17227 3.62946 2.26709 3.46067 2.43587C3.29189 2.60465 3.19707 2.83357 3.19707 3.07227ZM8.59707 9.67227V10.5723H8.89707C8.97664 10.5723 9.05294 10.6039 9.1092 10.6601C9.16546 10.7164 9.19707 10.7927 9.19707 10.8723C9.19707 10.9518 9.16546 11.0281 9.1092 11.0844C9.05294 11.1407 8.97664 11.1723 8.89707 11.1723H2.29707C2.21751 11.1723 2.1412 11.1407 2.08494 11.0844C2.02868 11.0281 1.99707 10.9518 1.99707 10.8723C1.99707 10.7927 2.02868 10.7164 2.08494 10.6601C2.1412 10.6039 2.21751 10.5723 2.29707 10.5723H2.59707V3.07227C2.59707 2.67444 2.75511 2.29291 3.03641 2.01161C3.31771 1.7303 3.69925 1.57227 4.09707 1.57227H7.09707C7.4949 1.57227 7.87643 1.7303 8.15773 2.01161C8.43904 2.29291 8.59707 2.67444 8.59707 3.07227V8.47227C8.59707 8.71096 8.69189 8.93988 8.86067 9.10866C9.02946 9.27744 9.25838 9.37227 9.49707 9.37227C9.73577 9.37227 9.96468 9.27744 10.1335 9.10866C10.3022 8.93988 10.3971 8.71096 10.3971 8.47227V5.87247C10.3971 5.67773 10.3339 5.48825 10.2171 5.33247L9.55707 4.45227C9.50933 4.38861 9.48883 4.3086 9.50009 4.22984C9.51134 4.15107 9.55342 4.08 9.61707 4.03227C9.68072 3.98453 9.76073 3.96403 9.8395 3.97528C9.91826 3.98653 9.98933 4.02861 10.0371 4.09227L10.6971 4.97247C10.8921 5.23167 10.9971 5.54787 10.9971 5.87247V8.47227C10.9971 8.75083 10.9195 9.0239 10.773 9.26086C10.6266 9.49783 10.4171 9.68933 10.1679 9.81391C9.91873 9.93849 9.6398 9.99122 9.36236 9.96621C9.08492 9.94119 8.81992 9.83941 8.59707 9.67227ZM3.79707 3.07227V5.47227C3.79707 5.55183 3.82868 5.62814 3.88494 5.6844C3.9412 5.74066 4.01751 5.77227 4.09707 5.77227H7.09707C7.17664 5.77227 7.25294 5.74066 7.3092 5.6844C7.36546 5.62814 7.39707 5.55183 7.39707 5.47227V3.07227C7.39707 2.9927 7.36546 2.91639 7.3092 2.86013C7.25294 2.80387 7.17664 2.77227 7.09707 2.77227H4.09707C4.01751 2.77227 3.9412 2.80387 3.88494 2.86013C3.82868 2.91639 3.79707 2.9927 3.79707 3.07227ZM4.39707 3.37227H6.79707V5.17227H4.39707V3.37227Z"
                                fill="#6E6E7C"
                              />
                            </svg>
                            <p>
                              $
                              {item?.data?.gasUsd
                                ? convertFixed(Number(item?.data?.gasUsd))
                                : 0}
                            </p>
                          </div>
                        </RoutesRecommendLeft>
                        <RoutesRecommendRight>
                          <h1>
                            {item?.data?.destAmount
                              ? convertFixed(
                                  Number(
                                    Coins.fromNano(
                                      item?.data?.destAmount
                                        ? item?.data?.destAmount
                                        : 0,
                                      item.data?.destDecimals
                                        ? item.data?.destDecimals
                                        : 0
                                    )
                                  )
                                )
                              : 0.0}
                          </h1>
                        </RoutesRecommendRight>
                      </RoutesRecommendItem>
                    );
                  } else {
                    <></>;
                  }
                })}
              </RoutesRecommended>
            )}
          </>
        )}
        <SwapDetailButton
          className={showDetail ? `active ${theme}` : theme}
          onClick={() => {
            setShowDetail(!showDetail);
          }}
        >
          <DetailButtonHeader
            className={theme}
            style={{
              marginBottom: showDetail ? "10px" : "0",
            }}
          >
            <p>Show detail</p>
            <p>{showDetail ? "Show less" : "Show more"}</p>
          </DetailButtonHeader>
          <SwapDetails
            showDetail={showDetail}
            realPrice={realPrice}
            fromAsset={fromAsset}
            toAsset={toAsset}
            slippageTolerance={slippageTolerance}
            minReceived={minReceived}
            simulateState={simulateState}
          />
        </SwapDetailButton>
        {address || addressTon ? (
          <>
            <SwapWrapperButtons>
              <ButtonCommon
                className={theme}
                onClick={() => {
                  setOpenConfirmModal(true);
                }}
                disabled={
                  fromAmount === 0 ||
                  toAmount === 0 ||
                  !fromAsset ||
                  !toAsset ||
                  loadingRouter ||
                  fromAmount > fromAssetBalance ? true : false ||
                  isFeeEnough ? false : true
                }
              >
                {Number(fromAmount) === 0 ? (
                  <p>Enter Amount</p>
                ) : Number(fromAmount) < Number(fromAssetBalance) &&
                  isFeeEnough ? (
                  <>
                    <p>{"Swap"}</p>
                    <img
                      style={{
                        marginLeft: "10px",
                      }}
                      src={swap_btn_icon}
                      alt="icon"
                    />
                  </>
                ) : (
                  <p>Insufficient Balance</p>
                )}
              </ButtonCommon>
            </SwapWrapperButtons>
          </>
        ) : (
          <ButtonCommon
            className={theme}
            onClick={() => {
              if (chainRouter === "Toncoin") {
                tonConnectUI.openModal();
              } else {
                open();
              }
            }}
          >
            <img
              width={17}
              height={17}
              style={{
                marginRight: "8px",
              }}
              src={wallet_icon}
              alt="wallet"
            />
            <p>Connect Wallet</p>
          </ButtonCommon>
        )}
      </SwapContent>
    </>
  );
};

export default SwapModal;
